export enum TheatreCategory {
    TraditionalPlay = 'Traditional Play',
    ShortPlay = 'Short Play',
    Sketch = 'Sketch',
    BlackTheatre = 'Black Theatre',
    ShadowTheatre = 'Shadow Theatre',
    MusicalTheatre = 'Musical Theatre',
    PhysicalSilentTheatre = 'Physical Silent Theatre',
    PuppetShow = 'Puppet Show',
    IndividualMonologue = 'Individual Monologue'
}

export enum TheatreEmailType {
    performanceAwaitingApproval = 0,
    performanceApproved = 1,
    performancePaymentAdded = 2,
    performancePaymentConfirmed = 3,
    performanceFileUploaded = 4,
    performanceSubmissionCompleted = 5,
    performanceReviewSubmitted = 6
}

export enum TheatreStatus {
    ScriptReviewRequired = 'Script Review Required',
    SubmissionFailed = 'Submission Failed',

    // Cannot submit without uploaded file / url
    PendingCoordinatorApproval = 'Pending Coordinator Approval',
    PendingPayment = 'Pending Payment',
    PendingScript = 'Pending Script',
    PendingReview = 'Pending Review',
    SubmissionCompleted = 'Submission Completed'
}
